// Logout do Keycloak sem depender do Auth do @finx/web-repository nem da ordem
// de inicialização do App — opera direto em window/document/storage, para
// funcionar em acesso por link direto (rota pública /sair), antes de o App montar.
// A limpeza de sessão local existe duplicada no legado (inicio.vue,
// LogoutConfigStore.authLogout) — consumo novo deve usar este util.

// Valor cru, sem normalizar: o oidc-client e o guard (router/_.ts) montam a
// chave do storage com a env var como está — normalizar aqui faria a chave
// divergir e o id_token não ser encontrado.
function getAuthority(): string {
  const win = window as any
  return win.KEYCLOAK_AUTHORITY_URL || win.API_FINX_AUTH || ''
}

function getRealm(): string {
  return (window as any).KEYCLOAK_REALM || 'finx'
}

function getClientId(): string {
  return (window as any).KEYCLOAK_CLIENT_ID || 'finx-front'
}

// Mesmo valor que o Oidc.ts do web-repository registra como post_logout_redirect_uri
// (sem normalizar) — precisa bater com as Valid post logout redirect URIs do realm.
function getPostLogoutRedirectUri(): string {
  const clientAddress = (window as any).CLIENT_ADDRESS || window.location.origin
  return `${clientAddress}/inicio`
}

// O token pode estar sob a chave nova (authority/realm:clientId) ou a legada
// (portal-client-2), dependendo de como a sessão foi criada.
function getIdToken(): string {
  const win = window as any
  const keys = [
    `oidc.user:${getAuthority()}/realms/${getRealm()}:${getClientId()}`,
    `oidc.user:${win.API_FINX_AUTH}:portal-client-2`,
  ]

  for (let i = 0; i < keys.length; i++) {
    try {
      const item = localStorage.getItem(keys[i])
      if (item) {
        // id_token é o nome do contrato OIDC (snake_case) — não traduzir.
        // eslint-disable-next-line camelcase
        const parsed: { id_token?: string } = JSON.parse(item)

        if (parsed && parsed.id_token) {
          return parsed.id_token
        }
      }
    } catch (e) {
      // chave ausente ou conteúdo inválido: tenta a próxima
    }
  }

  return ''
}

function clearSession(): void {
  try {
    localStorage.clear()
    sessionStorage.clear()
  } catch (e) {
    // storage indisponível (modo restrito do navegador): segue para o Keycloak
  }

  const cookies = document.cookie.split(';')
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i]
    const eqPos = cookie.indexOf('=')
    const name = (eqPos > -1 ? cookie.substr(0, eqPos) : cookie).trim()
    // Expirar exige o mesmo path com que o cookie foi gravado: a linha com
    // path=/ alcança os da raiz; a sem path, os gravados com o path default.
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`
  }
}

function buildLogoutUrl(idToken: string): string {
  let url = `${getAuthority()}/realms/${getRealm()}/protocol/openid-connect/logout`
  url += `?client_id=${encodeURIComponent(getClientId())}`
  url += `&post_logout_redirect_uri=${encodeURIComponent(getPostLogoutRedirectUri())}`

  // Com id_token_hint o Keycloak encerra a sessão direto; sem ele, exibe a tela
  // de confirmação antes de encerrar (comportamento padrão do Keycloak 18+).
  if (idToken) {
    url += `&id_token_hint=${encodeURIComponent(idToken)}`
  }

  return url
}

export {
  buildLogoutUrl,
  clearSession,
  getAuthority,
  getIdToken,
  getPostLogoutRedirectUri,
}
